module.exports = __webpack_public_path__ + "bg.acdba1c948dc774a24bd.jpg";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/assets/imgs/login/bg.jpg
// module id = ../../../../../src/assets/imgs/login/bg.jpg
// module chunks = main styles